import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/candidate/hall-page-background.png'
import _imports_1 from '@/assets/candidate/hall-page-fade.png'
import _imports_2 from '@/assets/candidate/exam-back-button@1.5x.png'
import _imports_3 from '@/assets/candidate/exam-hero-background@1.5x.png'
import _imports_4 from '@/assets/candidate/exam-stat-background@1.5x.png'
import _imports_5 from '@/assets/candidate/exam-stat-subjects@1.5x.png'
import _imports_6 from '@/assets/candidate/exam-stat-score@1.5x.png'
import _imports_7 from '@/assets/candidate/exam-stat-status@1.5x.png'
import _imports_8 from '@/assets/candidate/exam-play@1.5x.png'


const _hoisted_1 = { class: "candidate-page candidate-exam" }
const _hoisted_2 = { class: "candidate-exam__container" }
const _hoisted_3 = { class: "candidate-exam__header candidate-page-header" }
const _hoisted_4 = { class: "candidate-exam__identity" }
const _hoisted_5 = {
  key: 2,
  class: "exam-layout"
}
const _hoisted_6 = { class: "exam-main" }
const _hoisted_7 = { class: "exam-hero" }
const _hoisted_8 = { class: "exam-hero__content" }
const _hoisted_9 = { class: "exam-hero__title-row" }
const _hoisted_10 = { class: "exam-mode-tag" }
const _hoisted_11 = { class: "exam-status-tag" }
const _hoisted_12 = { class: "exam-meta" }
const _hoisted_13 = { class: "exam-stats-section" }
const _hoisted_14 = { class: "exam-stats" }
const _hoisted_15 = { class: "exam-stat" }
const _hoisted_16 = { class: "exam-stat__copy" }
const _hoisted_17 = { class: "exam-stat" }
const _hoisted_18 = { class: "exam-stat__copy" }
const _hoisted_19 = { class: "exam-stat" }
const _hoisted_20 = { class: "exam-stat__copy" }
const _hoisted_21 = { class: "exam-subjects" }
const _hoisted_22 = { class: "exam-subject-grid" }
const _hoisted_23 = { class: "exam-subject-icon" }
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "exam-subject-copy" }
const _hoisted_26 = { class: "exam-subject-tags" }
const _hoisted_27 = { class: "exam-action" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  key: 2,
  class: "exam-action-error"
}

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { $enum } from '@/global/index'
import CandidatePromptDialog from '@/components/candidate/CandidatePromptDialog.vue'
import {
  VkButton,
  VkCard,
  VkEmpty,
  VkTag,
} from '@/components/candidate/ui/index'
import {
  getPilotAssessmentSessionDetail,
  PilotAssessmentExamTimeStatus,
  PilotAssessmentSessionDetail,
  PilotAssessmentSessionSubject,
  startOrResumePilotAssessmentRound,
} from '@/service'

type SessionStatus = 'upcoming' | 'running' | 'ended'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const actionLoading = ref(false)
const errorMessage = ref('')
const actionError = ref('')
const session = ref<PilotAssessmentSessionDetail | null>(null)
const examEndedDialogVisible = ref(false)
let detailRequestSequence = 0

const status = computed<SessionStatus>(() => {
  if (!session.value) return 'ended'
  const value = String(session.value.examTimeStatus || '').trim().toUpperCase()
  if (
    session.value.canEnter ||
    value === 'RUNNING' ||
    value === 'IN_PROGRESS' ||
    value === 'ONGOING' ||
    value === '进行中'
  ) {
    return 'running'
  }
  if (
    value === 'UPCOMING' ||
    value === 'NOT_STARTED' ||
    value === 'PENDING' ||
    value === '未开始'
  ) {
    return 'upcoming'
  }
  return 'ended'
})
const statusLabel = computed(() =>
  status.value === 'running' ? '进行中' : status.value === 'upcoming' ? '未开始' : '已结束',
)
const sessionSubjects = computed<PilotAssessmentSessionSubject[]>(() => {
  if (!session.value) return []
  if (Array.isArray(session.value.subjects)) return session.value.subjects
  if (Array.isArray(session.value.enabledSubjects)) return session.value.enabledSubjects
  return []
})
const highestScoreText = computed(() => {
  const score = session.value?.highestScore
  if (score === null || score === undefined || score === '') return '--'
  const numericScore = Number(score)
  return Number.isFinite(numericScore) ? numericScore.toFixed(1) : String(score)
})
const hasActiveRound = computed(
  () => session.value?.activeRoundId !== null && session.value?.activeRoundId !== undefined,
)
const completedSubjectCount = computed(() =>
  hasActiveRound.value ? Number(session.value?.completedSubjectCount || 0) : 0,
)
const totalSubjectCount = computed(() =>
  Number(session.value?.totalSubjectCount || sessionSubjects.value.length || 0),
)
const progressPercentage = computed(() => {
  if (!totalSubjectCount.value) return 0
  return Math.round((completedSubjectCount.value / totalSubjectCount.value) * 100)
})
const progressRingStyle = computed(() => ({
  '--exam-progress-value': progressPercentage.value,
  '--exam-progress-opacity': progressPercentage.value > 0 ? 1 : 0,
}))
const actionHint = computed(() => {
  if (!session.value?.canEnter) return `当前场次${statusLabel.value}，暂不可开始或继续考试。`
  return hasActiveRound.value
    ? '当前存在未完成考试，请继续完成剩余科目。'
    : '在有效时间内可开始新一轮考试。'
})

function goHall() {
  router.push('/pilot-assesment')
}

async function loadSessionDetail() {
  const requestSequence = ++detailRequestSequence
  const sessionId = String(route.params.sessionId || '')
  if (!sessionId) {
    session.value = null
    loading.value = false
    errorMessage.value = '缺少考试场次信息'
    return
  }
  loading.value = true
  errorMessage.value = ''
  actionError.value = ''
  try {
    const response = await getPilotAssessmentSessionDetail({ sessionId })
    if (requestSequence !== detailRequestSequence) return
    if (response.code != $enum.EnumResult.SUCCESS || !response.data) {
      throw new Error(response.message || '考试信息加载失败')
    }
    session.value = response.data
    examEndedDialogVisible.value =
      response.data.examTimeStatus === PilotAssessmentExamTimeStatus.ENDED
  } catch (error) {
    if (requestSequence !== detailRequestSequence) return
    session.value = null
    examEndedDialogVisible.value = false
    errorMessage.value = error instanceof Error ? error.message : '考试信息加载失败'
  } finally {
    if (requestSequence === detailRequestSequence) loading.value = false
  }
}

async function handleAction() {
  if (!session.value?.canEnter || actionLoading.value) return
  actionLoading.value = true
  actionError.value = ''
  try {
    const response = await startOrResumePilotAssessmentRound({
      sessionId: session.value.sessionId,
    })
    if (response.code != $enum.EnumResult.SUCCESS || !response.data?.roundId) {
      throw new Error(response.message || '开始考试失败')
    }
    await router.push({
      name: 'CandidateSubjects',
      params: { sessionId: String(session.value.sessionId) },
      query: { roundId: String(response.data.roundId) },
    })
  } catch (error) {
    actionError.value = error instanceof Error ? error.message : '开始考试失败'
  } finally {
    actionLoading.value = false
  }
}

function subjectTone(subjectCode: string): 'blue' | 'orange' | 'purple' {
  if (subjectCode === 'BASE_FLIGHT') return 'blue'
  if (subjectCode === 'DISTRIBUTION_INSPECTION') return 'orange'
  return 'purple'
}

function subjectIconSource(subjectCode: string) {
  if (subjectCode === 'BASE_FLIGHT') {
    return require('@/assets/candidate/exam-subject-flight@1.5x.png')
  }
  if (subjectCode === 'DISTRIBUTION_INSPECTION') {
    return require('@/assets/candidate/exam-subject-distribution@1.5x.png')
  }
  return require('@/assets/candidate/exam-subject-tower@1.5x.png')
}

function handleExamEndedConfirm() {
  sessionStorage.removeItem('pilotAssessmentTrainingContext')
  router.replace({ name: 'CandidateHome' })
}

watch(
  () => route.params.sessionId,
  () => loadSessionDetail(),
  { immediate: true },
)

onBeforeUnmount(() => {
  detailRequestSequence += 1
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", {
      class: "candidate-exam__background",
      "aria-hidden": "true"
    }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }),
      _createElementVNode("img", {
        src: _imports_1,
        alt: ""
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(VkButton), {
            class: "candidate-exam__back",
            variant: "text",
            tone: "default",
            debounce: false,
            "aria-label": "返回考试大厅",
            onClick: goHall
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_2,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }),
          _cache[2] || (_cache[2] = _createElementVNode("div", null, [
            _createElementVNode("h1", null, "考试页面"),
            _createElementVNode("p", null, "查看场次信息、考试次数与当前考试进度")
          ], -1))
        ])
      ]),
      (loading.value)
        ? (_openBlock(), _createBlock(_unref(VkCard), {
            key: 0,
            class: "candidate-card candidate-empty"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VkEmpty), {
                size: "large",
                description: "考试信息加载中..."
              })
            ]),
            _: 1
          }))
        : (errorMessage.value)
          ? (_openBlock(), _createBlock(_unref(VkCard), {
              key: 1,
              class: "candidate-card candidate-empty"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(VkEmpty), {
                  size: "large",
                  description: errorMessage.value
                }, null, 8, ["description"])
              ]),
              _: 1
            }))
          : (session.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("section", _hoisted_6, [
                  _createElementVNode("section", _hoisted_7, [
                    _cache[6] || (_cache[6] = _createElementVNode("img", {
                      class: "exam-hero__background",
                      src: _imports_3,
                      alt: ""
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("h2", null, _toDisplayString(session.value.sessionName), 1),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(session.value.participateMode === 2 ? '定向模式' : '公开模式'), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(statusLabel.value), 1)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(actionHint.value), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", null, "考试时间", -1)),
                          _createElementVNode("strong", null, _toDisplayString(session.value.validStartTime) + " ～ " + _toDisplayString(session.value.validEndTime), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", null, "考试模式", -1)),
                          _createElementVNode("strong", null, _toDisplayString(session.value.participateMode === 2 ? '定向模式' : '公开模式'), 1)
                        ]),
                        _cache[5] || (_cache[5] = _createElementVNode("div", null, [
                          _createElementVNode("span", null, "考试须知"),
                          _createElementVNode("strong", null, "请在规定时间内完成全部科目")
                        ], -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_13, [
                    _cache[16] || (_cache[16] = _createElementVNode("h3", null, "数据统计", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _cache[8] || (_cache[8] = _createElementVNode("img", {
                          class: "exam-stat__background",
                          src: _imports_4,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_16, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", null, "考试科目", -1)),
                          _createElementVNode("strong", null, _toDisplayString(totalSubjectCount.value), 1)
                        ]),
                        _cache[9] || (_cache[9] = _createElementVNode("img", {
                          class: "exam-stat__icon",
                          src: _imports_5,
                          alt: ""
                        }, null, -1))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[11] || (_cache[11] = _createElementVNode("img", {
                          class: "exam-stat__background",
                          src: _imports_4,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[10] || (_cache[10] = _createElementVNode("span", null, "历史最高分", -1)),
                          _createElementVNode("strong", null, _toDisplayString(highestScoreText.value), 1)
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("img", {
                          class: "exam-stat__icon",
                          src: _imports_6,
                          alt: ""
                        }, null, -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[14] || (_cache[14] = _createElementVNode("img", {
                          class: "exam-stat__background",
                          src: _imports_4,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_20, [
                          _cache[13] || (_cache[13] = _createElementVNode("span", null, "考试状态", -1)),
                          _createElementVNode("strong", null, _toDisplayString(statusLabel.value), 1)
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("img", {
                          class: "exam-stat__icon",
                          src: _imports_7,
                          alt: ""
                        }, null, -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("section", _hoisted_21, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "exam-subjects__title" }, [
                      _createElementVNode("h3", null, "本场次考试科目"),
                      _createElementVNode("span", null, "满分 100 · 通过线 80")
                    ], -1)),
                    _createElementVNode("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sessionSubjects.value, (subject) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: subject.subjectCode,
                          class: _normalizeClass(["exam-subject-item", `is-${subjectTone(subject.subjectCode)}`])
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("img", {
                              src: subjectIconSource(subject.subjectCode),
                              alt: ""
                            }, null, 8, _hoisted_24)
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("h4", null, _toDisplayString(subject.subjectName), 1),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("span", null, "总分 " + _toDisplayString(subject.fullScore), 1),
                              _createElementVNode("span", null, "通过线 " + _toDisplayString(subject.passScore), 1),
                              _createElementVNode("span", null, "权重 " + _toDisplayString(subject.weightPercent) + "%", 1)
                            ])
                          ])
                        ], 2))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("aside", _hoisted_27, [
                  (hasActiveRound.value)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_28, [
                        _cache[18] || (_cache[18] = _createTextVNode(" 继续第 ")),
                        _createElementVNode("strong", null, _toDisplayString(session.value.activeRoundNo), 1),
                        _cache[19] || (_cache[19] = _createTextVNode(" 次考试 "))
                      ]))
                    : (_openBlock(), _createElementBlock("h3", _hoisted_29, "开始新一轮考试")),
                  _createElementVNode("p", null, _toDisplayString(hasActiveRound.value
                ? '当前有一轮进行中的考试，请先完成剩余科目。'
                : '当前没有进行中的考试，可开始新的考试轮次。'), 1),
                  _createElementVNode("div", {
                    class: "exam-progress-ring",
                    style: _normalizeStyle(progressRingStyle.value)
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("svg", {
                      class: "exam-progress-ring__chart",
                      viewBox: "0 0 200 200",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("circle", {
                        class: "exam-progress-ring__track",
                        cx: "100",
                        cy: "100",
                        r: "93.5",
                        pathLength: "100"
                      }),
                      _createElementVNode("circle", {
                        class: "exam-progress-ring__value",
                        cx: "100",
                        cy: "100",
                        r: "93.5",
                        pathLength: "100"
                      })
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("strong", null, _toDisplayString(completedSubjectCount.value) + " / " + _toDisplayString(totalSubjectCount.value), 1),
                      _cache[20] || (_cache[20] = _createElementVNode("span", null, "已完成科目", -1))
                    ])
                  ], 4),
                  _createVNode(_unref(VkButton), {
                    class: "exam-action-button",
                    block: "",
                    size: "large",
                    variant: "solid",
                    tone: "primary",
                    disabled: !session.value.canEnter || actionLoading.value,
                    loading: actionLoading.value,
                    onClick: handleAction
                  }, {
                    default: _withCtx(() => [
                      _cache[22] || (_cache[22] = _createElementVNode("img", {
                        class: "exam-action-icon",
                        src: _imports_8,
                        alt: ""
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(hasActiveRound.value ? '继续考试' : '开始考试'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"]),
                  (actionError.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(actionError.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
    ]),
    _createVNode(CandidatePromptDialog, {
      modelValue: examEndedDialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((examEndedDialogVisible).value = $event)),
      title: "提示",
      message: "考试时间已结束，系统已自动终止当次考试。",
      "confirm-text": "确认",
      "cancel-text": "取消",
      "show-cancel": false,
      "show-close": false,
      onConfirm: handleExamEndedConfirm
    }, null, 8, ["modelValue"])
  ]))
}
}

})